import React from 'react'
import { Icon, latLng, Marker, Popup } from '@fareye/ui'
// import { Exception } from '../../utils/types'
import { hhmmADoMMMYYYY, isNullUndefinedAndEmpty } from '@fareye/utils'
import { displayTime } from '../../utility/function'
import { parseDoorData, parseTemperature, useTranslation } from '@fareye/common'

interface LatestVehiclePingMarkerProps {
  data: any
  iconUrl?: string
  iconSize?: [number, number]
  type?: string
}

export function LatestVehiclePingMarker({
  iconUrl,
  iconSize,
  data,
  type = ''
}: any) {
  const { t } = useTranslation()
  const {
    landmark,
    speed,
    state,
    istTimestamp,
    latitude,
    longitude,
    gpsTimestamp,
    extraData = {}
  } = data || {}
  let speedStr = `${isNullUndefinedAndEmpty(speed) ? '-' : speed + ' Km/hr'}`
  let temperature = parseTemperature(
    extraData?.temperature ?? extraData?.sensorData
  )
  const doorsData = parseDoorData(extraData?.sensorData)
  return (
    <Marker
      position={latLng(Number(latitude), Number(longitude))}
      icon={
        new Icon({
          iconUrl: iconUrl || 'https://i.ibb.co/4KHscxB/Polygon-1.png',
          iconSize: iconSize || [15, 15],
          iconAnchor: [7, 15]
        })
      }
    >
      <Popup minWidth={149}>
        <h5>
          <strong>{t('Ping Details')}:</strong>
        </h5>
        <strong>{t('Landmark')}</strong>: {t(landmark)}
        <br />
        <strong>{t('Speed')}</strong>: {speedStr}
        <br />
        <strong>{t('Vehicle Status')}</strong>: {t(state)}
        <br />
        {temperature && (
          <>
            <strong>{t('Temperature')}</strong>: {temperature}
            <br />
          </>
        )}
        {doorsData && (
          <>
            <strong>{t('Doors')}</strong>: {doorsData}
            <br />
          </>
        )}
        {extraData?.tampering && (
          <>
            <strong>{t('Tampering')}</strong>: {extraData?.tampering}
            <br />
          </>
        )}
        <strong>{t('Time')}</strong>:
        {type === 'UTC'
          ? displayTime(gpsTimestamp)
          : hhmmADoMMMYYYY(istTimestamp)}
      </Popup>
    </Marker>
  )
}
